import { InjectionToken } from '@angular/core';
import type { Observable } from 'rxjs';

/** Job-role catalogue entry, as far as a position-create dialog needs it. */
export interface SelectableJobRole {
  id: string;
  name: string;
}

/**
 * Minimal interface for listing the job-role catalogue (`planning/job-roles`).
 * Implemented app-side over `JobRoleService` from `@zag/planning/ui`.
 *
 * Same rationale as {@link AssignableRolesSource}: `@zag/timetracking/ui`'s
 * org-chart editor needs the catalogue for its "Neue Position" dialog (PO
 * feedback 2026-07-09 — a raw ID text field is not usable), but must not
 * import `@zag/planning/ui` directly (domain-boundary decision, spec
 * org-chart-position-editor Phase 4b gap 3). The token lives in `@zag/ui`
 * so app-level route providers can bridge the two lazy domains.
 *
 * @example
 * // In app route providers:
 * { provide: JOB_ROLES_SOURCE, useClass: JobRolesSourceAdapter }
 *
 * // In a library component:
 * private readonly jobRolesSource = inject(JOB_ROLES_SOURCE, { optional: true });
 */
export interface JobRolesSource {
  /** One-shot load of the full catalogue, sorted by name. */
  jobRoles(): Observable<SelectableJobRole[]>;
}

export const JOB_ROLES_SOURCE = new InjectionToken<JobRolesSource>('JOB_ROLES_SOURCE');
